import {gql} from '@apollo/client';

export const QUERY_WIDGETS = gql`
query widgets($filters: WidgetFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []) {
    widgets(filters: $filters,pagination: $pagination, sort: $sort) {
        documentId
        identifier
        value
        message
        createdAt
    }
}`

